export default "__VITE_ASSET__a5b62681__"